import Image from 'next/image';
import Link from 'next/link';

import { TextKeyValuePair } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import { useIsMobile } from '@/helpers/screenResolutionHelper';

const trendingServices = [
  {
    alt: 'corporate event image',
    cardImg: 'corporate-events.jpg',
    subTitle: 'Effortless event solutions',
    title: 'CORPORATE EVENTS',
    url: 'https://book.hafla.com/pages/corporate'
  },
  {
    alt: 'wedding engagement image',
    cardImg: 'wedding-event.jpg',
    subTitle: 'Celebrate Love in Style',
    title: 'WEDDINGS & ENGAGEMENT',
    url: 'https://book.hafla.com/pages/wedding'
  }
];

const TrendingServices = () => {
  const [isMobile] = useIsMobile();

  return (
    <div className='flex grid grid-cols-1 md:grid-cols-2 place-items-center justify-self-center gap-4 md:gap-6'>
      {trendingServices.map(({ alt, cardImg, subTitle, title, url }) => (
        <Link
          href={url}
          key={title}
          rel='noopener noreferrer'
          target='_blank'
        >
          <div className='relative w-full justify-self-center'>
            <div className='relative gradient-container'>
              <div className='z-10 bottom-overlay inner-content gradient-border hover:shadow-lg'>
                <Image
                  alt={alt}
                  height={isMobile ? 376 : 640}
                  priority={true}
                  src={`${staticMediaStoreBaseURL}/home-page/${cardImg}`}
                  width={isMobile ? 320 : 545}
                  style={{
                    objectFit: 'contain',
                    width: isMobile ? '320px' : '545px',
                    height: isMobile ? '376px' : '640px'
                  }}
                />
              </div>
            </div>
            <div className='flex flex-col gap-1 md:gap-2 absolute bottom-8 md:bottom-10 z-50 left-5 md:left-6'>
              <TextKeyValuePair
                {...{
                  className:
                    'flex-col trending-services-title-mobile subpixel-antialiased',
                  label: title,
                  labelClass:
                    'uppercase text-lg md:text-2xl font-semibold text-white',
                  spaceTop: '',
                  value: subTitle,
                  valueClassName:
                    'trending-services-sub-title-mobile md:!text-base font-medium italic text-white md:pb-0 pb-3'
                }}
              />

              <Image
                alt='get started icon'
                className='cursor-pointer'
                height={isMobile ? 22 : 56}
                src={`${staticMediaStoreBaseURL}/icons/get-started.svg`}
                width={isMobile ? 100 : 178}
                style={{
                  width: isMobile ? '100px' : '178px',
                  height: isMobile ? '22px' : '56px',
                  objectFit: 'contain'
                }}
              />
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default TrendingServices;
